import React, { useEffect, useRef } from "react";
import Phaser from "phaser";
/* character imports */
import carrotImg from "../assets/games/carrot-game/carrot.png";
import carrotImg2 from "../assets/games/carrot-game/carrot2.png";
import carrotImg33 from "../assets/games/carrot-game/carrot-33.png";
import carrotImg233 from "../assets/games/carrot-game/carrot2-33.png";
import carrotImg66 from "../assets/games/carrot-game/carrot-66.png";
import carrotImg266 from "../assets/games/carrot-game/carrot2-66.png";
import carrotImgSad from "../assets/games/carrot-game/carrot-sad.png";
import candyImg1 from "../assets/games/carrot-game/candy1.png";
import candyImg2 from "../assets/games/carrot-game/candy2.png";
import candyImg3 from "../assets/games/carrot-game/candy3.png";
import candyImg4 from "../assets/games/carrot-game/candy4.png";
import candyImg5 from "../assets/games/carrot-game/candy5.png";
import candyImg6 from "../assets/games/carrot-game/candy6.png";
import candyImg7 from "../assets/games/carrot-game/candy7.png";
import candyImg8 from "../assets/games/carrot-game/candy8.png";
import candyImg9 from "../assets/games/carrot-game/candy9.png";
import candyImg10 from "../assets/games/carrot-game/candy10.png";
import candyImg11 from "../assets/games/carrot-game/candy11.png";
import candyImg12 from "../assets/games/carrot-game/candy12.png";
import broccoliImg from "../assets/games/carrot-game/broccoli.png";
import broccoliImg2 from "../assets/games/carrot-game/broccoli2.png";
import broccoliImg3 from "../assets/games/carrot-game/broccoli3.png";
import broccoliImg4 from "../assets/games/carrot-game/broccoli4.png";
import gameWinPolaroid from "../assets/games/carrot-game/carrot-game-polaroid.png";

/* environments imports */
import groundImg from "../assets/games/carrot-game/ground.png";
import treesImg from "../assets/games/carrot-game/trees.png";
import skyBgImg from "../assets/games/carrot-game/sky-bg.jpg";
import mountainsImg from "../assets/games/carrot-game/mountains.png";
import cloudsImg from "../assets/games/carrot-game/clouds.png";

const CarrotGame = () => {
  const gameRef = useRef(null);

  const initPhaserGame = () => {
    const aspectRatio = 20 / 7;
    const screenWidth = window.innerWidth;
    const screenHeight = screenWidth / aspectRatio;
    const scaleFactor = screenWidth / 1000; // 1000 is base width used earlier

    const MainScene = new Phaser.Class({
      Extends: Phaser.Scene,

      initialize: function () {
        Phaser.Scene.call(this, { key: "MainScene" });
        this.carrot = null;
        this.candies = null;
        this.broccoli = null;
        this.scoreText = null;
        this.isGameOver = false;
        this.gameStarted = false;
        this.broccoliReached = false;
        this.broccoliOverlapAdded = false;
        this.score = 0;
        this.lives = 3;
        this.ground = null;
        this.lastCandyTime = 0;
        this.skyBg = null;
        this.mountains = null;
        this.clouds = null;
        this.trees = null;
        this.candySpawnTimer = null;
        this.winImage = null;
      },

      preload: function () {
        /* Characters */
        this.load.image("carrot", carrotImg);
        this.load.image("carrot2", carrotImg2);
        this.load.image("carrot33", carrotImg33);
        this.load.image("carrot233", carrotImg233);
        this.load.image("carrot66", carrotImg66);
        this.load.image("carrot266", carrotImg266);
        this.load.image("carrotSad", carrotImgSad);
        this.load.image("candy1", candyImg1);
        this.load.image("candy2", candyImg2);
        this.load.image("candy3", candyImg3);
        this.load.image("candy4", candyImg4);
        this.load.image("candy5", candyImg5);
        this.load.image("candy6", candyImg6);
        this.load.image("candy7", candyImg7);
        this.load.image("candy8", candyImg8);
        this.load.image("candy9", candyImg9);
        this.load.image("candy10", candyImg10);
        this.load.image("candy11", candyImg11);
        this.load.image("candy12", candyImg12);
        this.load.image("broccoli", broccoliImg);
        this.load.image("broccoli2", broccoliImg2);
        this.load.image("broccoliHappy", broccoliImg3);
        this.load.image("broccoliSad", broccoliImg4);
        /* Environment */
        this.load.image("ground", groundImg);
        this.load.image("skyBg", skyBgImg);
        this.load.image("mountains", mountainsImg);
        this.load.image("clouds", cloudsImg);
        this.load.image("trees", treesImg);
        /* win image */
        this.load.image("winImage", gameWinPolaroid);
      },

      create: function () {
        this.cameras.main.setRoundPixels(true);
        const screenWidth = this.sys.game.config.width;
        const screenHeight = this.sys.game.config.height;
        const EnvScaleFactor = screenWidth / 1920;

        /* Environments */
        this.skyBg = this.add
          .tileSprite(0, 0, 1920, 672, "skyBg")
          .setOrigin(0, 0)
          .setScale(EnvScaleFactor)
          .setScrollFactor(0)
          .setDepth(-5);

        this.clouds = this.add
          .tileSprite(0, 10 * EnvScaleFactor, 1920, 180, "clouds")
          .setOrigin(0, 0)
          .setScale(EnvScaleFactor)
          .setScrollFactor(0)
          .setDepth(-4);

        // Ground
        const mountainsHeight = 366 * EnvScaleFactor;
        const treesHeight = 285 * EnvScaleFactor;
        const groundHeight = 125 * EnvScaleFactor;
        const groundTopY = screenHeight - groundHeight;

        this.mountains = this.add
          .tileSprite(
            0,
            groundTopY - 0.15 * treesHeight - mountainsHeight,
            1920,
            366,
            "mountains"
          )
          .setOrigin(0, 0)
          .setScale(EnvScaleFactor)
          .setScrollFactor(0)
          .setDepth(-3);

        this.trees = this.add
          .tileSprite(
            0,
            groundTopY - treesHeight + 25 * EnvScaleFactor,
            1920,
            285,
            "trees"
          )
          .setOrigin(0, 0)
          .setScale(EnvScaleFactor)
          .setScrollFactor(0)
          .setDepth(-2);

        this.ground = this.add
          .tileSprite(0, groundTopY, 1920, 125, "ground")
          .setOrigin(0, 0)
          .setScale(EnvScaleFactor)
          .setScrollFactor(0);

        const colliderHeight = 20 * scaleFactor;
        this.groundCollider = this.physics.add.staticGroup();

        this.groundCollider
          .create(screenWidth / 2, screenHeight - colliderHeight / 2, null)
          .setDisplaySize(screenWidth, colliderHeight)
          .setVisible(false) // true for debug
          .refreshBody();

        // Carrot and Broccoli — placed on top
        const baseY = screenHeight - colliderHeight;

        this.carrot = this.physics.add
          .sprite(30 * scaleFactor, baseY - 40 * scaleFactor, "carrot")
          .setScale(0.3 * scaleFactor);

        this.broccoli = this.physics.add
          .sprite(
            screenWidth - 40 * scaleFactor,
            baseY - 40 * scaleFactor,
            "broccoli"
          )
          .setScale(0.2 * scaleFactor);

        // collisions
        this.physics.add.collider(this.carrot, this.groundCollider);
        this.physics.add.collider(this.broccoli, this.groundCollider);

        // Candy group
        this.candies = this.physics.add.group();

        // HUD text
        this.scoreText = this.add
          .text(screenWidth / 2, 12 * scaleFactor, "Tries: 3 | Score: 0", {
            fontSize: `${16 * scaleFactor}px`,
            fill: "#000000",
          })
          .setOrigin(0.5, 0);

        this.startText = this.add
          .text(
            screenWidth / 2,
            screenHeight / 2 - 20 * scaleFactor,
            "Press SPACE or Tap to Start",
            { fontSize: `${24 * scaleFactor}px`, fill: "#000000" }
          )
          .setOrigin(0.5, 0);

        this.winImage = this.add
          .image(40 * scaleFactor, screenHeight - 120 * scaleFactor, "winImage")
          .setOrigin(0.5)
          .setScale(0.2 * scaleFactor)
          .setAlpha(0)
          .setDepth(10)
          .setVisible(false);

        const characterJumpGameStart = () => {
          if (!this.gameStarted && !this.isGameOver) {
            this.gameStarted = true;
            this.startText.destroy();
            this.carrot.setTexture("carrot"); // reset to base texture
            this.broccoli.setTexture("broccoli"); // reset to base texture
            this.runTimer = this.time.addEvent({
              delay: 100,
              loop: true,
              callback: () => {
                if (
                  this.carrot.body.blocked.down &&
                  this.gameStarted &&
                  !this.isGameOver
                ) {
                  const current = this.carrot.texture.key;
                  if (this.lives === 2) {
                    this.carrot.setTexture(
                      current === "carrot33" ? "carrot233" : "carrot33"
                    );
                  } else if (this.lives === 1) {
                    this.carrot.setTexture(
                      current === "carrot66" ? "carrot266" : "carrot66"
                    );
                  } else if (this.lives <= 0) {
                    this.triggerGameOver();
                  } else {
                    this.carrot.setTexture(
                      current === "carrot" ? "carrot2" : "carrot"
                    );
                  }
                }
              },
            });
            this.broccoliRunTimer = this.time.addEvent({
              delay: 100,
              loop: true,
              callback: () => {
                if (this.gameStarted && !this.isGameOver) {
                  const currentBroccoli = this.broccoli.texture.key;
                  this.broccoli.setTexture(
                    currentBroccoli === "broccoli" ? "broccoli2" : "broccoli"
                  );
                }
              },
            });
          } else if (this.carrot.body.blocked.down && !this.isGameOver) {
            if (this.score <= 3100) {
              this.carrot.setVelocityY(-710 * scaleFactor);
            }
            // this.carrot.setTexture("carrot");
            if (this.lives === 2) {
              this.carrot.setTexture("carrot33");
            } else if (this.lives === 1) {
              this.carrot.setTexture("carrot66");
            } else if (this.lives <= 0) {
              this.triggerGameOver();
            } else {
              this.carrot.setTexture("carrot");
            }
          }
        };

        // Input - Jump
        this.input.keyboard.on("keydown-SPACE", () => {
          characterJumpGameStart();
        });

        this.input.on("pointerdown", () => {
          characterJumpGameStart();
        });

        // Restart
        const restartGame = () => {
          this.scene.restart();
          this.isGameOver = false;
          this.broccoliReached = false;
          this.broccoliOverlapAdded = false;
          this.gameStarted = false;
          this.lives = 3;
          this.score = 0;
          this.lastCandyTime = 0;
        };

        this.input.keyboard.on("keydown-R", () => {
          if (this.isGameOver || this.broccoliReached) restartGame();
        });

        this.input.on("pointerdown", () => {
          if (this.isGameOver || this.broccoliReached) restartGame();
        });

        // Candy Spawner
        this.candySpawnTimer = this.time.addEvent({
          delay: 200 * scaleFactor,
          loop: true,
          callback: () => {
            if (!this.gameStarted || this.isGameOver || this.broccoliReached)
              return;

            const now = this.time.now * scaleFactor;
            const delay = Phaser.Math.Between(
              1000 * scaleFactor,
              2500 * scaleFactor
            );

            if (this.score <= 2900 && now - this.lastCandyTime > delay) {
              const yOptions = [
                screenHeight - 50 * scaleFactor,
                screenHeight - 70 * scaleFactor,
                screenHeight - 90 * scaleFactor,
                screenHeight - 110 * scaleFactor,
                screenHeight - 130 * scaleFactor,
              ];
              const y = Phaser.Math.RND.pick(yOptions);
              const candyTypes = [
                "candy1",
                "candy2",
                "candy3",
                "candy4",
                "candy5",
                "candy6",
                "candy7",
                "candy8",
                "candy9",
                "candy10",
                "candy11",
                "candy12",
              ];
              const candyKey = Phaser.Math.RND.pick(candyTypes);

              const candy = this.candies
                .create(screenWidth - 80 * scaleFactor, y, candyKey)
                .setScale(0.25 * scaleFactor);

              candy.setVelocityX(-250 * scaleFactor);
              candy.body.setAllowGravity(false);
              this.lastCandyTime = now;
            }
          },
        });

        // Candy collision
        this.physics.add.overlap(this.carrot, this.candies, (carrot, candy) => {
          candy.destroy();
          this.lives--;
          this.carrot.setTint(0xff0000, 0x00ff00, 0x0000ff, 0xff00ff, 0x00ffff);
          const timer = setTimeout(() => {
            this.carrot.clearTint();
          }, 500);

          this.updateHUD();
          if (this.lives <= 0) {
            clearTimeout(timer);
            this.triggerGameOver();
          }
        });

        /* Broccoli and carrot collision */

        this.physics.add.overlap(this.carrot, this.broccoli, () => {
          if (this.broccoliReached) return;

          this.add
            .text(screenWidth / 2, 40 * scaleFactor, "You win!", {
              fontSize: `${28 * scaleFactor}px`,
              fill: "#aab216",
            })
            .setOrigin(0.5, 0);
          this.add
            .text(
              screenWidth / 2,
              screenHeight - 50 * scaleFactor,
              "Press R or Tap to Restart",
              {
                fontSize: `${24 * scaleFactor}px`,
                fill: "#ffffff",
              }
            )
            .setOrigin(0.5, 0);

          this.broccoli.setVelocityX(0);
          this.broccoli.setTexture("broccoliHappy");
          this.isGameOver = true;
          this.candies.clear(true, true);
          this.broccoliReached = true;
          if (this.candySpawnTimer) this.candySpawnTimer.remove();

          const flash = this.add
            .rectangle(
              screenWidth / 2,
              screenHeight / 2,
              screenWidth,
              screenHeight,
              0xffffff
            )
            .setDepth(9);

          this.tweens.add({
            targets: flash,
            alpha: 0,
            duration: 600,
            ease: "Cubic.easeOut",
            onComplete: () => flash.destroy(),
          });

          this.winImage.setVisible(true);

          this.tweens.add({
            targets: this.winImage,
            x: screenWidth / 2,
            y: screenHeight / 2,
            scale: 0.45 * scaleFactor,
            alpha: 1,
            ease: "Back.Out",
            duration: 500,
          });
        });
      },

      updateHUD: function () {
        this.scoreText.setText(`Tries: ${this.lives} | Score: ${this.score}`);
      },

      triggerGameOver: function () {
        this.isGameOver = true;
        this.carrot.clearTint();
        this.carrot.setTexture("carrotSad");
        this.broccoli.setVelocityX(0);
        this.broccoli.setTexture("broccoliSad");
        this.candies.clear(true, true);
        if (this.runTimer) this.runTimer.remove();
        if (this.broccoliRunTimer) this.broccoliRunTimer.remove();
        if (this.candySpawnTimer) this.candySpawnTimer.remove();

        this.add
          .text(screenWidth / 2, 100 * scaleFactor, "GAME OVER", {
            fontSize: `${30 * scaleFactor}px`,
            fill: "#ff4444",
          })
          .setOrigin(0.5, 0);

        this.add
          .text(
            screenWidth / 2,
            150 * scaleFactor,
            "Press R or Tap to Restart",
            {
              fontSize: `${24 * scaleFactor}px`,
              fill: "#000000",
            }
          )
          .setOrigin(0.5, 0);

        this.add.text(
          this.broccoli.x - 90 * scaleFactor,
          screenHeight - 80 * scaleFactor,
          "OHHHH!",
          {
            fontSize: `${16 * scaleFactor}px`,
            fill: "#ff4444",
          }
        );

        this.add.text(
          45 * scaleFactor,
          screenHeight - 80 * scaleFactor,
          "SORRY!",
          {
            fontSize: `${16 * scaleFactor}px`,
            fill: "#ff4444",
          }
        );
      },

      update: function (_, delta) {
        if (this.isGameOver || !this.gameStarted) return;

        this.score += Math.floor(delta / 10);
        this.updateHUD();

        const scrollSpeed = 300;
        this.ground.tilePositionX += (scrollSpeed * delta) / 1000;
        this.trees.tilePositionX += (scrollSpeed * delta) / 3000;
        this.mountains.tilePositionX += (scrollSpeed * delta) / 5000;
        this.clouds.tilePositionX += (scrollSpeed * delta) / 10000;

        this.candies.getChildren().forEach((candy) => {
          if (candy.x < -50) candy.destroy();
        });

        if (
          this.score >= 3000 &&
          !this.broccoliReached &&
          !this.broccoliOverlapAdded
        ) {
          this.broccoliOverlapAdded = true;
          this.broccoli.setVelocityX(-250 * scaleFactor);
          this.broccoli.body.setAllowGravity(false);
        }
      },
    });

    // Destroy previous game
    if (gameRef.current) {
      gameRef.current.destroy(true);
      gameRef.current = null;
    }

    const game = new Phaser.Game({
      type: Phaser.AUTO,
      width: screenWidth,
      height: screenHeight,
      parent: "gameContainer",
      physics: {
        default: "arcade",
        arcade: {
          gravity: { y: 1500 * scaleFactor },
          debug: false,
        },
      },
      scene: MainScene,
    });

    gameRef.current = game;
  };

  useEffect(() => {
    initPhaserGame();

    const handleResize = () => {
      initPhaserGame();
    };

    window.addEventListener("resize", handleResize);

    console.log("CarrotGame useEffect");

    return () => {
      window.removeEventListener("resize", handleResize);
      if (gameRef.current) {
        gameRef.current.destroy(true);
        gameRef.current = null;
      }
    };
  }, []);

  return <div id="gameContainer" className="game-container" />;
};

export default CarrotGame;
